export const createLocalStorage = () => {
  let storage;
  const fallbackStorage = {};

  if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
    storage = window.localStorage;
  } else {
    storage = {
      getItem: (key) => fallbackStorage[key],
      setItem: (key, value) => { fallbackStorage[key] = value; },
    };
  }

  return {
    getItem: (key) => storage?.getItem(key),
    setItem: (key, value) => storage.setItem(key, value),
  };
};

export const createSessionStorage = () => {
  let storage;
  const fallbackStorage = {};

  if (typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined') {
    storage = window.sessionStorage;
  } else {
    storage = {
      getItem: (key) => fallbackStorage[key],
      setItem: (key, value) => { fallbackStorage[key] = value; },
    };
  }

  return {
    getItem: (key) => storage.getItem(key),
    setItem: (key, value) => storage.setItem(key, value),
  };
};
